// extracted by mini-css-extract-plugin
module.exports = {"title":"Title_title___9A9a","marked":"Title_marked__chwna"};